@if (applyStyling) {
  <div class="text-[14px] mx-2 text-right leading-4 notranslate">
    {{ today | localdate: 'EEEE, d MMMM' }}
    <span class="inline md:hidden lg:inline">|</span>
    <br class="hidden md:inline lg:hidden" />
    <span> {{ 'common.week' | translate }} </span>
    {{ today | localdate: 'w' }}
  </div>
} @else {
  {{ today | localdate: 'EEEE, d MMMM' }} | {{ 'common.week' | translate }}
  {{ today | localdate: 'w' }}
}
